import * as React from "react";
import { Upload } from "lucide-react";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UploadModalContent } from "@/views/drive/modals/uploadModal/content";

interface UploadModalProps {
  currentFolderId?: string;
  isReadOnly?: boolean;
}

export const UploadModal: React.FC<UploadModalProps> = ({ currentFolderId, isReadOnly }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="default" disabled={isReadOnly}>
          <Upload className="mr-2 h-5 w-5" />
          Upload
        </Button>
      </DialogTrigger>
      {isOpen && <UploadModalContent currentFolderId={currentFolderId} setIsOpen={setIsOpen} />}
    </Dialog>
  );
};
